import React, { Component } from "react";
import {
  redirectToDashboard,
  redirectToLogin,
} from "../../store/actions/auth/authActions";
import { Cache } from "aws-amplify";

class Authenticator extends Component {
  isUserAuthenticated = async () => {
    const authToken = Cache.getItem("token");
    if (authToken) {
      if (!window.location.href.includes("dashboard")) {
        redirectToDashboard();
      }
    } else {
      await this.authenticateUser();
    }
  };

  authenticateUser = async () => {
    const authToken = Cache.getItem("token");
    if (!authToken) {
      redirectToLogin();
    } else {
      if (!window.location.href.includes("dashboard")) {
        redirectToDashboard();
      }
    }
  };

  render() {
    this.isUserAuthenticated();
    return <></>;
  }
}

export default Authenticator;
